export default __webpack_public_path__ + "static/media/pic6.84be4f30.png";